export const isLoggedIn = () => document.body.dataset.loggedIn === 'true';
